import * as React from 'react';
import { connect } from 'react-redux';
import { User } from 'oidc-client';
import { AppState } from '../../store';
import { Row, Col, Card } from 'react-bootstrap';
import GroupsTable from "./GroupsTable";

type GroupProps = {
    user: User;
}

class Groups extends React.Component<GroupProps> {

    public render(){

        const username = !this.props.user ? "" : `${this.props.user.profile.given_name} ${this.props.user.profile.family_name}`;

        return(
            <React.Fragment>
                <Row>
                    <Col>
                        <Card className="panel">
                            <Card.Header>
                                <Row>
                                    <Col md={12}>
                                        <h3>Groups</h3>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                <GroupsTable />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state: AppState) {
    return {
        user: state.oidc.user,
    };
}


export default connect(
    mapStateToProps
)(Groups as any);
